import * as React from 'react';
import styled from 'styled-components';
import { MenuContext } from './Menu';
import { useAutocomplete } from './use-autocomplete';

export const SearchInput = (props: { history: any }) => {
  const context = React.useContext(MenuContext);

  const [query, setQuery] = React.useState('');
  const [active, setActive] = React.useState(0);

  const input: any = React.useRef(null);
  const autoCompleteList: any = React.useRef(null);
  const formRef: any = React.useRef(null);

  React.useEffect(() => {
    input.current.focus();
  }, []);

  const onChange = (e: any) => {
    setQuery(e.target.value);
    handleGetAutocomplete(e.target.value);
  };

  const closeSearch = () => {
    context.setMenuState({
      ...context.menuState,
      searchVisible: !context.menuState.searchVisible
    });
  };

  const saveSearch = async () => {
    try {
      const res = await fetch('https://pmapi.reeltime.no/newapi/savesearch', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          q: query.toLowerCase()
        })
      });
      return true;
    } catch (e) {
      console.log('feil ved søk');
    }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    closeSearch();
    await saveSearch();
    document.location.href = `https://privatmegleren.no?q=${encodeURIComponent(
      query.toLowerCase()
    )}`;
  };

  const { list, handleGetAutocomplete } = useAutocomplete({
    query: query
  });

  const close = () => {
    context.setMenuState({
      ...context.menuState,
      searchVisible: !context.menuState.searchVisible
    });
  };

  const focusChange = (e: any) => {
    if (e.keyCode === 40) {
      e.preventDefault();
      if (autoCompleteList && autoCompleteList.current) {
        autoCompleteList.current.focus();
      }
      setActive(1);
    }
  };

  return (
    <>
      <SearchWrap>
        <form ref={formRef} action="." onSubmit={handleSubmit}>
          <SearchIcon>
            <svg
              width="31"
              height="31"
              viewBox="0 0 31 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.7224 27.2685L20.605 18.1494C22.0073 16.3081 22.7964 13.9408 22.7964 11.3976C22.7964 5.08477 17.7116 0 11.3988 0C5.08597 0 -0.000488281 5.08645 -0.000488281 11.3993C-0.000488281 17.7121 5.08428 22.7969 11.3971 22.7969C13.9403 22.7969 16.2188 22.0078 18.1489 20.6055L27.268 29.7246C27.6181 30.0747 28.0571 30.2506 28.496 30.2506C28.935 30.2506 29.3722 30.0747 29.7241 29.7246C30.4244 29.0226 30.4244 27.9704 29.7224 27.2685L29.7224 27.2685ZM11.3988 19.2903C7.01432 19.2903 3.50776 15.7837 3.50776 11.3993C3.50776 7.01481 7.01432 3.50825 11.3988 3.50825C15.7833 3.50825 19.2898 7.01481 19.2898 11.3993C19.2898 15.7821 15.7816 19.2903 11.3988 19.2903Z"
                fill=""
              ></path>
            </svg>
          </SearchIcon>
          <Input
            type="search"
            placeholder="Skriv ditt søkeord her.."
            ref={input}
            value={query}
            onChange={onChange}
            onKeyDown={focusChange}
            autoFocus
          />
        </form>
        <div>
          {list && list.length && query ? (
            <StyledAutocompleteList
              tabIndex={-1}
              ref={autoCompleteList}
              onKeyDown={(e: any) => {
                e.preventDefault();
                if (e.keyCode === 38) {
                  const prevIndex = active === 0 ? active : active - 1;
                  setActive(prevIndex);
                  setQuery(list[prevIndex].text);
                  if (active === 0) {
                    console.log('nå traff denne');
                    // forwardedRef.current.focus();
                  }
                } else if (e.keyCode === 40) {
                  const nextIndex =
                    active + 1 < list.length ? active + 1 : active;
                  setActive(nextIndex);
                  setQuery(list[nextIndex].text);
                } else if (e.keyCode === 13) {
                  setQuery(list[active].text);
                  handleSubmit(e);
                }
              }}
            >
              {list.map((item, index: number) => (
                <StyledAutocompleteListItem
                  id={`a_${index}`}
                  active={active === index}
                  tabIndex={index}
                  key={`a_${index}`}
                  onFocus={() => {
                    setQuery(item.text);
                  }}
                  onClick={(e: any) => {
                    setQuery(item.text);
                    handleSubmit(e);
                  }}
                >
                  {item.text}
                </StyledAutocompleteListItem>
              ))}
            </StyledAutocompleteList>
          ) : null}
        </div>
      </SearchWrap>
    </>
  );
};

const SearchWrap = styled.div`
  position: absolute;
  left: 0;
  top: 64px;
  right: 0;
  bottom: 0px;
  margin: 0 30px;

  @media (min-width: 1140px) {
    left: 12px;
    top: 13px;
    right: 0;
    top: 14px;
    bottom: 0px;
    width: calc(100% - 140px);
    margin: auto;

    svg {
      width: 18px;
      height: 18px;
      fill: rgb(100, 100, 100);
    }
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  top: 7px;
  bottom: 0px;
  width: 18px;
  height: 18px;
  margin-left: 10px;
  z-index: 1;

  svg {
    fill: rgb(100, 100, 100) !important;
  }
`;

const Input = styled.input`
  width: 100%;
  font-size: 18px;
  font-weight: 400;
  color: rgb(255, 255, 255) !important;
  appearance: none;
  padding: 0.5rem 0.9375rem 0.5rem 2.25rem !important;
  border-width: initial;
  border-style: none;
  border-color: initial;
  border-image: initial;
  outline: none;
  border: none !important;
  background: rgb(30, 30, 30) !important;
  border-radius: 0px;
  height: 37px;
`;

const StyledAutocompleteList = styled.ul`
  position: absolute;
  top: 2.3125rem;
  padding: 0;
  margin: 0;
  width: 100%;
  background: rgb(25, 25, 25);
  list-style: none;
  outline: none;
`;

const StyledAutocompleteListItem = styled.li<any>`
  padding: 0.5rem 0.9375rem !important;
  margin: 0 !important;
  color: white;
  border-bottom: solid 1px rgb(40, 40, 40);
  ${(props) => (props.active ? `background: rgb(35, 35, 35);` : '')}

  &:last-child {
    border-bottom: none;
  }

  &:focus {
    background: rgb(35, 35, 35);
    outline: none;
  }

  &:hover {
    cursor: pointer;
    background: rgb(35, 35, 35);
  }
`;

const Close = styled.div`
  display: inline;
  color: white;
  font-size: 18px;
  font-weight: 300;
  cursor: pointer;
`;
